import { useEffect } from 'react';

import { AppStateStatus } from 'react-native';

import useNoInternetAlertVisible from 'components/NoInternetAlert/hooks/useNoInternetAlertVisible';

type Props = {
    focused: boolean;
    fullscreen: boolean;
    appState: AppStateStatus;
    onCloseFullscreen(): void;
};

const useCloseFullscreenPlayerOnNoInternet = ({
    fullscreen,
    appState,
    focused,
    onCloseFullscreen,
}: Props) => {
    const { visible: noInternetAlertVisible } = useNoInternetAlertVisible(true);

    useEffect(() => {
        if (
            noInternetAlertVisible &&
            focused &&
            fullscreen &&
            appState === 'active'
        ) {
            onCloseFullscreen();
        }
    }, [noInternetAlertVisible, focused, fullscreen, appState]);
};

export default useCloseFullscreenPlayerOnNoInternet;
